/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: zhanmei
 * @Date: 2020-07-31 15:16:47
 * @LastEditors: zhanmei
 * @LastEditTime: 2020-09-08 16:39:04
 */
var $ = require('jQuery');
var Component = require('./Component');
var template = require('../template/chat-float.html');
var utils = require('../global/utils');
var isEmpty = utils.isEmpty;
var IEVersion = utils.IEVersion;


var ChatFloat = function (options) {
  (function (self) {
    var defaults = {
      template: template,
      member: '<div class="chat-float-member"><div class="float-avatar"><img class="float-avatar-img" src="{src}"></div><div class="float-member-name"><span>{name}</span></div></div>'
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
  })(this);

  (function (self) {

  })(this);
};
ChatFloat.prototype = Object.create(Component.prototype);
ChatFloat.prototype.init = function (container) {
  var self = this;
  self.container = container;
  self.hideSelf = (function () {
    this.hide();
  }).bind(self);
  this.bindEvent();
};
ChatFloat.prototype.reAppend = function () {
  var self = this;
  if (self.container) {
    self.container.html(self._options.template);
    self.bindEvent();
  }
};
ChatFloat.prototype.bindEvent = function () {
  var self = this;
  var chat_float_add = (this.container || this._element).find('.chat-float-add');
  chat_float_add.click(function (e) {
    self.triggerEvent('chat_open_organiz');
  });
  (this.container || this._element).on('click', function (event) {
    event.stopPropagation();
  });
};
ChatFloat.prototype.renderContacts = function (contacts, id_sources) {
  var float_members = (this.container || this._element).find('.chat-float-members');
  var member_tpl = this._options.member;
  var html = '';
  if (!(!isEmpty(id_sources) && id_sources.length && !isEmpty(contacts))) return;
  (id_sources || []).forEach(function (id_source) {
    if (!isEmpty(contacts[id_source])) {
      html += member_tpl.replace('{src}', contacts[id_source].avatar || '').replace('{name}', contacts[id_source].remark_name || contacts[id_source].nick_name || contacts[id_source].user_name || '');
    }
  });
  float_members.html(html);
};
ChatFloat.prototype.show = function (text) {
  Component.prototype.show.call(this);
  this.opened = true;
};
ChatFloat.prototype.hide = function () {
  Component.prototype.hide.call(this);
  this.opened = false;
};
ChatFloat.prototype.getElement = function () {
  if (IEVersion() > 0) {
    return this._options.template;
  } else {
    return this._element;
  }
}

module.exports = ChatFloat;
